import { createContext, useContext } from 'react'

import { BpmnDiagramCallbacks } from './bpmn-diagram.types'

export const BpmnDiagramContext = createContext<BpmnDiagramCallbacks | null>(null)

export function useBpmnDiagramContext(): BpmnDiagramCallbacks {
  const context = useContext(BpmnDiagramContext)
  if (!context) {
    throw new Error('useBpmnDiagramContext must be used within a BpmnDiagram')
  }

  return context
}
